module.exports = __webpack_public_path__ + "img/logo-light.6539f1b0.svg";